// Generates a memorable, sufficiently-random default password for newly-created
// users (students / teachers / head-teachers). Format: <Word><Word>#<3-digit>
// e.g. "RisingTiger#742" — easy to read out, hard to guess, unique per call.
const ADJECTIVES = [
  'Rising', 'Bright', 'Swift', 'Calm', 'Bold', 'Clever', 'Eager', 'Gentle',
  'Happy', 'Kind', 'Lively', 'Lucky', 'Merry', 'Noble', 'Proud', 'Quick',
  'Sharp', 'Smart', 'Sunny', 'Wise',
];
const NOUNS = [
  'Tiger', 'Eagle', 'Lion', 'Falcon', 'Panda', 'Otter', 'Dolphin', 'Hawk',
  'Wolf', 'Fox', 'Bear', 'Cobra', 'Lynx', 'Heron', 'Owl', 'Sparrow',
  'Crane', 'Deer', 'Hare', 'Koala',
];

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

/**
 * Generate a default password like "BrightOtter#284".
 * Always returns a fresh value, so each newly created user gets a unique seed.
 */
export const generateDefaultPassword = () => {
  const num = String(Math.floor(100 + Math.random() * 900)); // 3-digit 100-999
  return `${pick(ADJECTIVES)}${pick(NOUNS)}#${num}`;
};

export default generateDefaultPassword;
